import { Person } from "./Person"
import { User } from "./User"

export type DemoMeeting =
  { id: number
  , demoGoals: string
  , demoNotes: string
  , howFound: string
  , status: DemoStatus
  , scheduledDurationMinutes: number
  , startAt: string
  , rescheduledAt: string
  , cancelledAt: string
  , completedAt: string
  , createdAt: string
  , updatedAt: string
  , cancellationMessage: string
  , rescheduleMessage: string
  , zoomJoinUrl?: string
  , presenterUser: User
  , person: Person
  }

export enum DemoStatus
  { ACTIVE = 'active'
  , COMPLETED = 'completed'
  , RESCHEDULED = 'rescheduled'
  , CANCELLED = 'cancelled'
  , CANCELLED_BY_PRESENTER = 'cancelled-by-presenter'
  }

export function adminDemoDetailsPath(demo: DemoMeeting) {
  return `/admin/demos/${demo.id}`
}
